import { BaseViewModel } from "./base.viewmodel";

export class PortfolioDetailsViewModel implements BaseViewModel {
    PageTitle: string = 'Portfolio Details';
}